"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_fetch_api_1 = require("@giphy/js-fetch-api");
const bricks_js_1 = __importDefault(require("bricks.js"));
const css_1 = require("@emotion/css");
const preact_1 = require("preact");
const throttle_debounce_1 = require("throttle-debounce");
const observer_1 = __importDefault(require("../util/observer"));
const fetch_error_1 = __importDefault(require("./fetch-error"));
const gif_1 = __importDefault(require("./gif"));
const loader_1 = __importDefault(require("./loader"));
const pingback_context_manager_1 = __importDefault(require("./pingback-context-manager"));
const loaderHiddenCss = (0, css_1.css) `
    opacity: 0;
`;
const defaultProps = Object.freeze({ gutter: 6, user: {} });
const initialState = Object.freeze({
    isFetching: false,
    isError: false,
    numberOfGifs: 0,
    gifWidth: 0,
    gifs: [],
    isLoaderVisible: true,
    isDoneFetching: false,
});
class Grid extends preact_1.Component {
    constructor() {
        super(...arguments);
        this.state = initialState;
        this.el = null;
        this.paginator = (0, js_fetch_api_1.gifPaginator)(this.props.fetchGifs);
        this.onLoaderVisible = (isVisible) => {
            this.setState({ isLoaderVisible: isVisible }, this.onFetch);
        };
        this.fetchGifs = (0, throttle_debounce_1.debounce)(Grid.fetchDebounce, (prefetchCount) => __awaiter(this, void 0, void 0, function* () {
            let gifs;
            try {
                gifs = yield this.paginator();
            }
            catch (error) {
                this.setState({ isFetching: false, isError: true });
                const { onGifsFetchError } = this.props;
                if (onGifsFetchError)
                    onGifsFetchError(error);
            }
            if (gifs) {
                // if we've just fetched and we don't have
                // any more gifs, we're done fetching
                if (prefetchCount === gifs.length) {
                    this.setState({ isDoneFetching: true });
                }
                else {
                    this.setState({ gifs, isFetching: false });
                    const { onGifsFetched } = this.props;
                    if (onGifsFetched)
                        onGifsFetched(gifs);
                    this.onFetch();
                }
            }
        }));
        this.onFetch = () => __awaiter(this, void 0, void 0, function* () {
            const { isFetching, isLoaderVisible, gifs } = this.state;
            if (!isFetching && isLoaderVisible) {
                this.setState({ isFetching: true, isError: false });
                this.fetchGifs(gifs.length);
            }
        });
    }
    static getDerivedStateFromProps({ columns, gutter, width }, prevState) {
        const gutterOffset = gutter * (columns - 1);
        const gifWidth = Math.floor((width - gutterOffset) / columns);
        if (prevState.gifWidth !== gifWidth) {
            return { gifWidth };
        }
        return {};
    }
    setBricks() {
        const { columns, gutter } = this.props;
        // bricks
        this.bricks = (0, bricks_js_1.default)({
            container: this.el,
            packed: `data-packed-${columns}`,
            sizes: [{ columns, gutter }],
        });
    }
    componentDidMount() {
        this.setBricks();
        this.onFetch();
    }
    componentDidUpdate(prevProps, prevState) {
        const { gifs } = this.state;
        const { gifWidth } = this.state;
        const numberOfOldGifs = prevState.gifs.length;
        const numberOfNewGifs = gifs.length;
        if (prevState.gifWidth !== gifWidth && numberOfOldGifs > 0) {
            const { columns } = this.props;
            if (columns !== prevProps.columns) {
                this.setBricks();
            }
            this.bricks.pack();
        }
        if (prevState.gifs !== gifs) {
            if (numberOfNewGifs > numberOfOldGifs && numberOfOldGifs > 0) {
                // we just added new gifs
                this.bricks.update();
            }
            else {
                // we changed existing gifs or removed a gif
                this.bricks.pack();
            }
        }
    }
    render({ onGifVisible, onGifRightClick, className = Grid.className, onGifClick, onGifHover, onGifKeyPress, onGifSeen, user, noResultsMessage, hideAttribution, noLink, tabIndex = 0, borderRadius, }, { gifWidth, gifs, isError, isDoneFetching }) {
        const showLoader = !isDoneFetching;
        const isFirstLoad = gifs.length === 0;
        return ((0, preact_1.h)(pingback_context_manager_1.default, { attributes: { layout_type: 'GRID' } },
            (0, preact_1.h)("div", { class: className },
                (0, preact_1.h)("div", { ref: (c) => (this.el = c) },
                    gifs.map((gif) => ((0, preact_1.h)(gif_1.default, { gif: gif, key: gif.id, tabIndex: tabIndex, width: gifWidth, onGifClick: onGifClick, onGifHover: onGifHover, onGifKeyPress: onGifKeyPress, onGifSeen: onGifSeen, onGifVisible: onGifVisible, onGifRightClick: onGifRightClick, user: user, hideAttribution: hideAttribution, noLink: noLink, borderRadius: borderRadius }))),
                    !showLoader && gifs.length === 0 && noResultsMessage),
                isError ? ((0, preact_1.h)(fetch_error_1.default, { onClick: this.onFetch })) : (showLoader && ((0, preact_1.h)(observer_1.default, { onVisibleChange: this.onLoaderVisible },
                    (0, preact_1.h)(loader_1.default, { className: (0, css_1.cx)(Grid.loaderClassName, isFirstLoad ? loaderHiddenCss : '') })))))));
    }
}
Grid.className = 'giphy-grid';
Grid.loaderClassName = 'giphy-loader';
Grid.defaultProps = defaultProps;
Grid.fetchDebounce = 250;
exports.default = Grid;
//# sourceMappingURL=grid.js.map